import { Outlet } from "react-router-dom";
import styles from './BlogLayout.module.scss';


export default function BlogLayout() {
    return (
        <div className={styles.bloglayout}>
            <h2>The Blog</h2>
            <p>A log of my posts and journey as we wrap up 2023 and set the foundation for some awesome projects in 2024!</p>

            <Outlet />
        </div>
    )
}